export default __webpack_public_path__ + "static/media/doc_posterior.be163f47.svg";